var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 28,
    viewBox: "0 0 34 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0834 26.75V23.9167C24.0834 22.4138 23.4864 20.9724 22.4237 19.9097C21.361 18.847 19.9196 18.25 18.4167 18.25H7.08341C5.58052 18.25 4.13918 18.847 3.07648 19.9097C2.01377 20.9724 1.41675 22.4138 1.41675 23.9167V26.75M32.5834 26.75V23.9167C32.5825 22.6611 32.1646 21.4414 31.3953 20.4491C30.6261 19.4568 29.5491 18.7481 28.3334 18.4342M22.6667 1.43417C23.8857 1.74626 24.9661 2.45516 25.7376 3.44911C26.5091 4.44305 26.9279 5.66551 26.9279 6.92375C26.9279 8.18199 26.5091 9.40445 25.7376 10.3984C24.9661 11.3923 23.8857 12.1012 22.6667 12.4133M18.4167 6.91667C18.4167 10.0463 15.8797 12.5833 12.7501 12.5833C9.62047 12.5833 7.08341 10.0463 7.08341 6.91667C7.08341 3.78705 9.62047 1.25 12.7501 1.25C15.8797 1.25 18.4167 3.78705 18.4167 6.91667Z",
    stroke: "#BCBCBC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.4c746a3ea029ef1c36d27db7f23760a4.svg";
export { ForwardRef as ReactComponent };